import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Cleans a phone number by removing spaces, periods, dashes, parentheses, and other non-numeric characters
 * except for + at the beginning (for international numbers)
 * @param phoneNumber - The phone number string to clean
 * @returns The cleaned phone number string
 */
export function cleanPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) return "";

  // Remove all non-numeric characters except + at the beginning
  return phoneNumber
    .replace(/[^\d+]/g, "") // Remove everything that's not a digit or +
    .replace(/^\++/, "+"); // Ensure only one + at the beginning
}

export function formatPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, '')
  const d = digits.startsWith('1') && digits.length > 10 ? digits.slice(1) : digits
  if (d.length <= 3) return d
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`
}

export function formatPhoneDisplay(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  const d = digits.startsWith('1') && digits.length > 10 ? digits.slice(1) : digits
  if (d.length !== 10) return phone
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`
}

export function isValidUSPhone(value: string): boolean {
  const digits = value.replace(/\D/g, '')
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'))
}

export function stripPhoneToDigits(value: string): string {
  return value.replace(/\D/g, '')
}
